import { render, staticRenderFns } from "./ImageAndText.vue?vue&type=template&id=8ae714c0"
import script from "./ImageAndText.vue?vue&type=script&lang=js"
export * from "./ImageAndText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports